import React, { Component } from 'react';

import './style/openCheckbox.scss';

export default class OpenCheckbox extends Component {
	state = {
		values: [],
		openOption: '',
		checkable: true,
		disabled: false,
	};

	componentDidMount() {
		const { valueField } = this.props;
		if (valueField) {
			this.setState({
				openOption: valueField.openOption,
				values: valueField.values,
			});
			this.validateMaxCheck(valueField.values);
		}
	}

	validateMaxCheck = (values) => {
		const { maxInput } = this.props;
		this.setState({ disabled: values.length >= maxInput });
	};

	updateValues() {
		const {
			values,
			openOption,
		} = this.state;

		const { nameField, onChange } = this.props;

		const data = {
			values,
			openOption,
		};

		const e = {
			target: {
				name: nameField,
				value: data,
			},
		};
		this.validateMaxCheck(values);

		onChange(e);
	}

	handleCheckClick(e) {
		const { values } = this.state;
		let { openOption } = this.state;

		const element = e.target;

		if (element.checked) {
			values.push(element.value);
		} else {
			values.splice(values.indexOf(element.value), 1);
			if (element.name === 'open') {
				openOption = '';
				const prevState = this.state;
				this.setState({ ...prevState, openOption });
			}
		}

		this.setState({
			values,
			openOption,
		}, this.updateValues);
	}

	handleOpenOption(e) {
		const { values } = this.state;
		if (values.indexOf('open') === -1 && e.target.value.length > 0) {
			values.push('open');
		}

		const { prevState } = this.state;
		this.setState({
			...prevState,
			values,
			openOption: e.target.value,
		}, this.updateValues);
	}

	renderOptions() {
		const {
			options,
			nameField,
			valueField,
			label,
		} = this.props;

		let parentValues = [];

		if (typeof valueField.values !== 'undefined') {
			parentValues = valueField.values;
		} else if (valueField.length > 0 && typeof valueField === 'string') {
			parentValues = JSON.parse(valueField).values;
		}

		return options.map((option) => {
			const {
				openOption,
				disabled,
			} = this.state;
			const idField = nameField + option.value;

			if (option.editable) {
				const isChecked = (parentValues.indexOf('open') !== -1);
				const isDisabled = disabled && !isChecked;
				return (
					<div className="form-check" key={option.value}>
						<label className="form-check-label container-option-field-text" htmlFor={idField}>
							<input
								className="form-check-input css-checkbox"
								type="checkbox"
								value="open"
								id={idField}
								name="open"
								onChange={this.handleCheckClick.bind(this)}
								checked={isChecked}
								disabled={isDisabled}
							/>
							<i />
							<input
								className="field-text"
								type="text"
								value={openOption}
								onChange={this.handleOpenOption.bind(this)}
								placeholder={option.label}
								readOnly={isDisabled}
							/>
						</label>
					</div>
				);
			}

			return (
				<div className="form-check" key={option.value}>
					<label className="form-check-label" htmlFor={idField}>
						<input
							className="form-check-input css-checkbox"
							type="checkbox"
							value={option.value}
							id={idField}
							name={nameField}
							onChange={this.handleCheckClick.bind(this)}
							checked={(parentValues.indexOf(option.value) !== -1)}
							disabled={disabled && !(parentValues.indexOf(option.value) !== -1)}
						/>
						<i />
						{option.label}
						{
							(typeof option.image !== 'undefined')
								? (
									<div className="checkbox-image">
										<img src={option.image} alt={label} />
									</div>
								)
								: ''
						}
					</label>
				</div>
			);
		});
	}

	render() {
		return (
			<div>
				{ this.renderOptions() }
			</div>
		);
	}
}
